import React from 'react';

import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';

export const EmailAddressLink = ({ className, emailAddress, mailTo }) => {
  const mailToEmailString = mailTo || emailAddress;
  return (
    <Button buttonTitle={emailAddress} className={className} href={`mailto:${mailToEmailString}`} theme='link'>
      {emailAddress}
    </Button>
  );
};

EmailAddressLink.propTypes = {
  className: PropTypes.string,
  emailAddress: PropTypes.string.isRequired,
  mailTo: PropTypes.string,
};
